<template>
  <div class="notification-auth-tg-hint">
    <h2 class="notification-auth-tg-hint__title mb-4">
      Отправлять уведомления о потере авторизации каналов получателям отчётов
    </h2>

    <ol class="notification-auth-tg-hint__list">
      <li class="notification-auth-tg-hint__item">
        При включении мы отправим уведомления о потере авторизации тем же
        контактам, что получают отчёты
        <p class="notification-auth-tg-hint__note mt-2">
          <strong><u>Важно!</u></strong> работает только если отчёты отправляются через
          «Бот Data Heroes (Telegram)»
        </p>
      </li>
      <li class="notification-auth-tg-hint__item">
        Посмотреть список отчётов и их получателей можно в блоке
        <a href="#" class="notification-auth-tg-hint__link" @click.prevent="openScheduledReportHint">«Отправка отчётов»</a>.
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'NotificationAuthTgHint',
  methods: {
    async openScheduledReportHint() {
      this.$store.commit('setIsHintSidebar', false)

      const scrollWithOffset = (el) => {
        const topOffset = 180
        const targetTop = el.getBoundingClientRect().top + window.pageYOffset - topOffset
        window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' })
      }

      const tryScroll = (attempt = 0) => {
        const target =
          document.getElementById('scheduled-report-section') ||
          document.getElementById('channels-section')

        if (target) {
          scrollWithOffset(target)
          const id = target.id
          const nextUrl = `${window.location.pathname}${window.location.search}#${id}`
          window.history.replaceState(null, '', nextUrl)
          return
        }

        if (attempt < 12) {
          setTimeout(() => tryScroll(attempt + 1), 50)
        }
      }

      const currentPath = this.$route?.path || window.location.pathname
      const isProjectMainPage = /^\/project\/[^/]+\/?$/.test(currentPath)

      if (!isProjectMainPage) {
        const projectId = this.$route?.params?.id
        if (projectId) {
          await this.$router.push(`/project/${projectId}`)
        }
      }

      setTimeout(() => tryScroll(0), 0)
    },
  },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.notification-auth-tg-hint
  color: #2A3B51
  width: 100%

.notification-auth-tg-hint__title
  font-size: 22px
  line-height: 28px
  font-weight: 500
  margin-bottom: 12px

.notification-auth-tg-hint__list
  margin: 0
  padding-left: 20px
  font-size: 14px
  line-height: 22px

.notification-auth-tg-hint__item
  margin-bottom: 8px

.notification-auth-tg-hint__note
  margin: 8px 0 0

.notification-auth-tg-hint__link
  color: $main
  text-decoration: underline
</style>
